// extracted by mini-css-extract-plugin
module.exports = {"notValidBrowser":"notValidBrowser--qLsYV","contact":"contact--tuAvb","browserList":"browserList--1Bk3V","logo":"logo--1t1e8"};